"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrueSizeView = exports.CSS = void 0;
var theme_1 = require("../../../components/theme");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    capture: 'c-TrueSize__capture'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.capture] = {
        padding: theme_1.DefaultTheme.space(1)
    },
    _a));
exports.TrueSizeView = {
    viewInline: function (field) {
        var captures = field.getCaptures();
        if (captures.length > 0) {
            return String(captures.length);
        }
        return '';
    },
    hasDetail: function (field) {
        return field.getCaptures().length > 0;
    },
    viewDetail: function (field) {
        var captures = [];
        var className = exports.CSS.capture;
        var imageCtx = { truesize: true, className: className, title: '' };
        var collection = field.collection;
        for (var _i = 0, _a = field.getCaptures(); _i < _a.length; _i++) {
            var capture = _a[_i];
            imageCtx.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            var dom = capture_thumbnail_1.CaptureThumbnail.view(collection, capture, imageCtx);
            captures.push(dom);
        }
        return mithril_1.m.fragment({}, captures);
    },
    viewEdit: function (field, state) {
        return exports.TrueSizeView.viewInline(field, state);
    },
    hasClear: function (field) {
        return false;
    }
};
//# sourceMappingURL=true.size.view.js.map